// extracted by mini-css-extract-plugin
export default {"summaryNumbersContainer":"styles_summaryNumbersContainer__EJ+FT","summaryText":"styles_summaryText__vgG7b"};